var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{staticClass:"mb-6"},[_c('infoTabela',{attrs:{"dados":_vm.dados}})],1),_c('vx-card',[_c('ListTabelaEstadoCidades',{attrs:{"dados":_vm.dados}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }